export const ALGOLIA_BYTE_LIMIT = 512

export function isQueryTooLong(query: string, byteLimit: number = ALGOLIA_BYTE_LIMIT) {
  return new Blob([query]).size > byteLimit
}
